module.exports = __webpack_public_path__ + "img/011_gerst_thumb.f4bf2894.jpg";